import React, { useEffect } from 'react';

export default function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  const isOpen = currentIndex !== null && currentIndex !== undefined && images && images[currentIndex];

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };

    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose, onPrev, onNext]);

  if (!isOpen) return null;

  const currentItem = images[currentIndex];
  const imageUrl = Array.isArray(currentItem.billede) ? currentItem.billede[0] : currentItem.billede;

  return (
    <div 
      className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 backdrop-blur-xs transition-opacity duration-300"
      onClick={onClose}
    >
      <div 
        className="relative max-w-5xl w-full max-h-[90vh] flex flex-col items-center justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          aria-label="Luk galleri"
          className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors p-2 text-2xl focus:outline-none"
        >
          <i className="fa-solid fa-xmark"></i>
        </button>

        {/* Prev Button */}
        {images.length > 1 && (
          <button
            onClick={onPrev}
            aria-label="Forrige billede"
            className="absolute left-2 sm:-left-12 top-1/2 -translate-y-1/2 bg-black/60 hover:bg-black/90 text-white p-3 transition-all focus:outline-none z-10"
          >
            <i className="fa-solid fa-chevron-left text-xl"></i>
          </button>
        )}

        {/* Main Image */}
        <div className="relative overflow-hidden shadow-2xl bg-black max-h-[75vh] flex items-center justify-center">
          <img
            src={imageUrl}
            alt={`${currentItem.titel || 'Referencebillede'} – ${currentItem.beskrivelse || 'Udført tømrerarbejde på Fyn af Fyns - Tømreren ApS'}`}
            className="max-h-[75vh] w-auto max-w-full object-contain"
          />
        </div>

        {/* Caption */}
        <div className="mt-4 text-center text-white max-w-2xl px-4">
          <p className="text-lg font-bold">{currentItem.titel}</p>
          {currentItem.beskrivelse && (
            <p className="text-sm text-gray-300 mt-1 leading-relaxed">{currentItem.beskrivelse}</p>
          )}
          {currentItem.kategori && (
            <p className="text-xs text-[#d75d5a] font-semibold mt-1 uppercase tracking-wider">{currentItem.kategori}</p>
          )}
          {images.length > 1 && (
            <p className="text-xs text-gray-400 mt-2">
              {currentIndex + 1} af {images.length}
            </p>
          )}
        </div>

        {/* Next Button */}
        {images.length > 1 && (
          <button
            onClick={onNext}
            aria-label="Næste billede"
            className="absolute right-2 sm:-right-12 top-1/2 -translate-y-1/2 bg-black/60 hover:bg-black/90 text-white p-3 transition-all focus:outline-none z-10"
          >
            <i className="fa-solid fa-chevron-right text-xl"></i>
          </button>
        )}
      </div>
    </div>
  );
}
